let elementsToPause = document.querySelectorAll('.pause-animation-on-blur')

if(elementsToPause){
    document.addEventListener("visibilitychange", function() {
        if (document.hidden){
            for(let elem of elementsToPause){


                let children = elem.querySelectorAll('*');

                for(let child of children){
                    child.style.animationPlayState = 'paused';
                }
                elem.style.animationPlayState = 'paused';
            }
        } else {
            for(let elem of elementsToPause){
                let children = elem.querySelectorAll('*');

                for(let child of children){
                    child.style.animationPlayState = 'running';
                }
                elem.style.animationPlayState = 'running';
            }
        }
    });
}
